import { useEffect, useState } from "react";
import { TypographyNumber } from "./numbers";
import { useTranslation } from "react-i18next";

export function MeetingTimer({ startTime }: { startTime: string }) {
  const [elapsed, setElapsed] = useState("00:00");
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      const start = new Date(startTime);
      const now = new Date();
      const ms = Math.max(0, now.getTime() - start.getTime());

      const minutes = Math.floor(ms / 60000)
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor((ms % 60000) / 1000)
        .toString()
        .padStart(2, "0");

      setElapsed(`${minutes}:${seconds}`);
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return (
    <h3 className="text-primary font-bold">
      <TypographyNumber value={elapsed} />
      <span className="font-semibold text-primary/80">
        {" " + t("in_meet_timer")}
      </span>
    </h3>
  );
}
